<template>
  <div>
    <v-select
      :value="value"
      :options="templates"
      :disabled="readonly"
      :multiple="multiple"
      :reduce="template => template.id"
      :loading="loading"
      dir="rtl"
      :clearable="multiple || clearable"
      :class="{'select-size-lg': size === 'lg', 'select-size-sm': size === 'sm', 'is-invalid': state === false}"
      autocomplete="off"
      @input="$emit('input', $event)"
    >
      <template
        slot="option"
        slot-scope="option"
      >
        <div
          class="d-center"
        >
          {{ option.name }}  ({{ $t('reply.'+option.message_type) }})
        </div>
      </template>
      <template
        slot="selected-option"
        slot-scope="option"
      >
        {{ option.name }} ({{ $t('reply.'+option.message_type) }})
      </template>
    </v-select>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'

export default {
  name: 'TemplatesSelect',
  components: {
    vSelect,
  },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    state: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      faceTemplates: 'reply/templates',
      instaTemplates: 'instagram/templates',
      isFacebook: 'auth/isFacebook',
    }),
    templates() {
      return this.isFacebook ? this.faceTemplates : this.instaTemplates
    },
  },
  mounted() {
    if (this.isFacebook) this.$store.dispatch('reply/GET_TEMPLATES')
  },
}
</script>
